export enum CollectionStatus {
    COMPLETE = 'COMPLETE',
    PARTIAL = 'PARTIAL',
    MISSING = 'MISSING',
    NOT_STARTED = 'NOT_STARTED'
}